import Component from 'vue-class-component'
import moduleStore from '../store/migu';
import Vue from 'vue';
import PageState from '../store/state';
import { toPublishPage } from '../utils/util';
import { MiguConfig } from '../utils/constant';

/**components**/
@Component({
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames
})
export default class VideoPlayPage extends Vue implements IvuePage<PageState> {
  state = new PageState();
  self: Vue = this;
  
  videoUrl: string;
  coverUrl: string;
  type: string = '1'; // 1: 作品播放页，可发布； 2：模板播放页，可创作同款
  isNewYear: boolean = false;
  taskId: string = '';
  articleId: string = '';
  watermark = require('@/assets/images/watermark.png');

  get isPublish() {
    return this.type === '1';
  }

  created() {
    this.isNewYear = localStorage.getItem('theme') === 'New_Year';
    const url = this.$route.query.videoUrl;
    if(typeof url === 'string') {
      this.videoUrl = url;
    }
    const coverUrl = this.$route.query.coverUrl;
    if(typeof coverUrl === 'string') {
      this.coverUrl = coverUrl;
    }
    const type = this.$route.query.type;
    if(typeof type === 'string') {
      this.type = type;
    }
    const taskId = this.$route.query.taskId;
    if(typeof taskId === 'string') {
      this.taskId = taskId;
    }
    const articleId = this.$route.query.articleId;
    if(typeof articleId === 'string') {
      this.articleId = articleId;
    }
  }

  mounted() {
    if(this.type === '2') {
      document.title = '视频播放';
    }
    this.$nextTick(() => {
      // 自动播放
      if(this.videoUrl && this.$refs.videoPlayer) {
        (this.$refs.videoPlayer  as any).play();
      }
    })
  }

  // 跳转发布页
  async toPublish() {
    const obj: any = {
      videoUrl: this.videoUrl,
      coverUrl: this.coverUrl,
    };
    if ((window as any)._amberTrack) {
      const vuid = localStorage.getItem('vuid') || '';
      (window as any)._amberTrack('music_aigc_publish_ringtone', [
        {
          EK: 'triggerType',
          EV: '2'
        },
        {
          EK: 'scene',
          EV: MiguConfig.projectId
        },
        {
          EK: 'videoUrl',
          EV: obj.videoUrl,
        },
        {
          EK: 'resId',
          EV: this.articleId || ''
        },
        {
          EK: 'vuid',
          EV: vuid
        },
        {
          EK: 'appId',
          EV: MiguConfig.appid
        },
        {
          EK: 'channel',
          EV: MiguConfig.schannel
        }
      ], true, 'beacon');
      console.log('_amberTrack music_aigc_publish_ringtone',
        {
          EK: 'videoUrl',
          EV: obj.videoUrl,
        },
        {
          EK: 'resId',
          EV: this.articleId || ''
        },
        {
          EK: 'vuid',
          EV: vuid
        }
      );
    }
    setTimeout(async () => {
      await toPublishPage(obj);
    }, 200);
  }

  // 跳转创作页
  toCreate() {
    const data = localStorage.getItem('videoMiguData')
    localStorage.setItem('textToVideoMiguData', data);
    try {
      if ((window as any)._amberTrack) {
        const vuid = localStorage.getItem('vuid') || '';
        (window as any)._amberTrack('music_aigc_submit_task_directly', [
          {
            EK: 'triggerType',
            EV: '2'
          },
          {
            EK: 'scene',
            EV: MiguConfig.projectId
          },
          {
            EK: 'taskId',
            EV: this.taskId
          },
          {
            EK: 'vuid',
            EV: vuid
          },
          {
            EK: 'appId',
            EV: MiguConfig.appid
          },
          {
            EK: 'channel',
            EV: MiguConfig.schannel
          }
        ], true, 'beacon');
        console.log('_amberTrack music_aigc_submit_task_directly',
          {
            EK: 'taskId',
            EV: this.taskId
          },
          {
            EK: 'vuid',
            EV: vuid
          }
        );
      }
    } catch (e) {}
    this.$router.replace({ path:'/migu' });
  }
}
